var _rect, _path, _path2, _path3, _g, _path4, _path5, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCloudIconInlineIntegration = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 33,
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "svg-public/img/icons/cloud_icon_inline_integration.svg__cloud_icon"
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  id: "svg-public/img/icons/cloud_icon_inline_integration.svg__Rectangle 25",
  x: -0.000976562,
  y: 0.988281,
  width: 32,
  height: 32,
  rx: 8,
  fill: "#0059EA"
})), /*#__PURE__*/React.createElement("g", {
  id: "svg-public/img/icons/cloud_icon_inline_integration.svg__Group 1321313766"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "svg-public/img/icons/cloud_icon_inline_integration.svg__Union",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.5991 21.2542C25.5991 18.4578 23.2691 16.1875 20.399 16.1875H9.999C7.12909 16.1875 4.79907 18.4578 4.79907 21.2542C4.79907 24.0506 7.12909 26.3208 9.999 26.3208H20.399C23.2691 26.3208 25.5991 24.0506 25.5991 21.2542Z",
  fill: "#FFC531"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "svg-public/img/icons/cloud_icon_inline_integration.svg__Fill 8",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.4656 7.6543C19.4393 7.6543 22.6656 10.8804 22.6656 14.8543C22.6656 18.8282 19.4393 22.0543 15.4656 22.0543C11.4918 22.0543 8.26562 18.8282 8.26562 14.8543C8.26562 10.8804 11.4918 7.6543 15.4656 7.6543Z",
  fill: "#FF9E00"
})), /*#__PURE__*/React.createElement("g", {
  id: "svg-public/img/icons/cloud_icon_inline_integration.svg__Mask Group"
}, /*#__PURE__*/React.createElement("mask", {
  id: "svg-public/img/icons/cloud_icon_inline_integration.svg__mask0_127_1730",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 4,
  y: 16,
  width: 11,
  height: 11
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  id: "svg-public/img/icons/cloud_icon_inline_integration.svg__Fill 2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.86567 16.1875C12.6621 16.1875 14.9324 18.4578 14.9324 21.2542C14.9324 24.0506 12.6621 26.3208 9.86567 26.3208C7.06935 26.3208 4.79907 24.0506 4.79907 21.2542C4.79907 18.4578 7.06935 16.1875 9.86567 16.1875Z",
  fill: "#FFC531"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#svg-public/img/icons/cloud_icon_inline_integration.svg__mask0_127_1730)"
}, /*#__PURE__*/React.createElement("path", {
  id: "svg-public/img/icons/cloud_icon_inline_integration.svg__Fill 3",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.4656 7.6543C19.4393 7.6543 22.6656 10.8804 22.6656 14.8543C22.6656 18.8282 19.4393 22.0543 15.4656 22.0543C11.4918 22.0543 8.26562 18.8282 8.26562 14.8543C8.26562 10.8804 11.4918 7.6543 15.4656 7.6543Z",
  fill: "#FFCF38"
})))), /*#__PURE__*/React.createElement("g", {
  id: "svg-public/img/icons/cloud_icon_inline_integration.svg__Group 1321313966"
}, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  id: "svg-public/img/icons/cloud_icon_inline_integration.svg__Fill 7",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.2656 11.9219C24.2395 11.9219 27.4657 15.1481 27.4657 19.1218C27.4657 23.0957 24.2395 26.3219 20.2656 26.3219C16.2919 26.3219 13.0657 23.0957 13.0657 19.1218C13.0657 15.1481 16.2919 11.9219 20.2656 11.9219Z",
  fill: "#FF6331"
})), /*#__PURE__*/React.createElement("g", {
  id: "svg-public/img/icons/cloud_icon_inline_integration.svg__Mask Group_2"
}, /*#__PURE__*/React.createElement("mask", {
  id: "svg-public/img/icons/cloud_icon_inline_integration.svg__mask1_127_1730",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 13,
  y: 11,
  width: 15,
  height: 16
}, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  id: "svg-public/img/icons/cloud_icon_inline_integration.svg__Fill 9",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.2656 11.9219C24.2395 11.9219 27.4657 15.1481 27.4657 19.1218C27.4657 23.0957 24.2395 26.3219 20.2656 26.3219C16.2919 26.3219 13.0657 23.0957 13.0657 19.1218C13.0657 15.1481 16.2919 11.9219 20.2656 11.9219Z",
  fill: "#FF6331"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#svg-public/img/icons/cloud_icon_inline_integration.svg__mask1_127_1730)"
}, /*#__PURE__*/React.createElement("path", {
  id: "svg-public/img/icons/cloud_icon_inline_integration.svg__Fill 8_2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.4656 7.65625C19.4393 7.65625 22.6656 10.8824 22.6656 14.8563C22.6656 18.8301 19.4393 22.0563 15.4656 22.0563C11.4918 22.0563 8.26562 18.8301 8.26562 14.8563C8.26562 10.8824 11.4918 7.65625 15.4656 7.65625Z",
  fill: "#FF6331"
}))))))));
export { SvgCloudIconInlineIntegration as ReactComponent };